<!-- ALERT TOAST-->
<p-toast></p-toast>

<!-- CONFIRMATION DIALOG-->
<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>

<!-- OVERLAY SCREEN-->
<div *ngIf="blocked" class="overlay">
    <img src="assets/layout/images/tovlogo.png" alt="{{translations.lbl_loading}}" class="loading-image" />
    <span style="color: white; font-size: large;">{{translations.lbl_loading}}</span>
</div>
<!-- GO BACK BUTTON -->


<p-toolbar styleClass="p-mb-4" *ngIf="device != '2'">
    <ng-template pTemplate="left">
        <button pButton pRipple label="{{translations.lbl_back}}" icon="pi pi-chevron-left"
            class="p-button-warning p-mr-2" (click)="goBack()"></button>
    </ng-template>
</p-toolbar>


<!-- MAIN SCREEN -->
<div class="card" *ngIf="translations">
    <!-- MAIN CONTENT -->
    <div class="p-grid">
        <div class="p-col-12 p-md-6">
            <p-panel>
                <!-- COORDINATION FORM -->
                <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                    <!-- GUIDE -->
                    <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                        <div class="subTitle p-col-12 p-md-4">
                            <span>{{translations.lbl_guide}}:</span>
                        </div>
                    </div>
                    <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                        <span class="p-text-bold">{{guide != null ? guide.name : "General Access"}} {{guide != null ?
                            guide.lastName :
                            ""}}</span>
                    </div>
                </div>
            </p-panel>
        </div>
    </div>
    <!-- TABLE -->
    <p-table #dt1 [value]="items" [showCurrentPageReport]="false" responsive="true">

        <!-- CAPTION -->
        <ng-template pTemplate="caption">
            <div class="p-d-flex p-ai-left p-jc-between responsive">
                <!-- MAIN TITLE-->
                <h5 class="p-md-6">{{translations.lbl_manuals_tutorials}}</h5>
            </div>
            <span class="p-input-icon-left">
                <!-- <button pButton pRipple label="" icon="pi pi-sync" class="p-button-danger p-m-2 z-5"
                    pTooltip="{{translations.lbl_reload}}" tooltipPosition="bottom"></button> -->
            </span>
        </ng-template>

        <!-- HEADER -->
        <ng-template pTemplate="header">
            <tr>
                <th>{{translations.lbl_id}}</th>
                <th>{{translations.lbl_name}}</th>
                <th class="text-right">{{translations.lbl_type}}</th>
                <th class="text-right">{{translations.lbl_select}}</th>
            </tr>
        </ng-template>

        <!-- BODY -->
        <ng-template pTemplate="body" let-product>
            <tr>
                <td>{{product.id.assistId}}</td>
                <td>{{product.descrip}}</td>
                <td class="text-right">{{product.type}}</td>
                <td class="text-right">
                    <button type="button" pButton pRipple icon="pi pi-search"
                        (click)="selectRecord(product.id.assistId)"></button>
                </td>
            </tr>
        </ng-template>

        <!-- SUMMARY -->
        <ng-template pTemplate="summary">
            <div class="flex align-items-center justify-content-between">
                {{translations.lbl_there_are}} {{items ? items.length : 0 }} {{translations.lbl_records}}.
            </div>
        </ng-template>
    </p-table>
</div>